import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class InboxControllerService {
  public currentMailId = new Subject<string>();

  currentMailId$ = this.currentMailId.asObservable();

  setCurrentMailid(id: string) {
    this.currentMailId.next(id);
  }
}
